<template>
    <div id="teamRankingsPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 d-flex flex-column m-auto">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('team.rank_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div v-if="config.seasonEnabled" class="row mb-3">
                        <div class="col-6 pr-1">
                            <b-button @click="setTab('gameweek');btnSfx();" size="lg" block :variant="currentTab == 'gameweek' ? 'tab' : 'outline-tab'">
                                {{ $t('team.rank_tab_gameweek') }}
                            </b-button>
                        </div>
                        <div class="col-6 pl-1">
                            <b-button @click="setTab('season');btnSfx();" size="lg" block :variant="currentTab == 'season' ? 'tab' : 'outline-tab'">
                                {{ $t('team.rank_tab_season') }}
                            </b-button>
                        </div>
                    </div>

                    <div class="mb-4">
                        <select v-model="selectedId" class="form-control">
                            <option v-for="o in options" :key="o.id" :value="o.id">
                                {{ timePeriodString(o.startDate, o.endDate) }}
                            </option>
                        </select>
                    </div>

                    <div v-if="userTeamRank != undefined && userTeamRank.rank > 6" class="my-team-rank mb-1">
                        <div class="my-team-rank__holder my-team">
                            <div :class="'team-list__order'+(userTeamRank.rank <= 3 ? ' team-list__order--rank-'+userTeamRank.rank : '')">{{ userTeamRank.rank }}</div>
                            <h5 class="mb-0 ml-3">{{ userTeamRank.team != undefined ? userTeamRank.team.name : '-' }}</h5>
                            <div class="team-list__right ml-auto">
                                <span v-if="userTeamRank.team != undefined"><b><img src="/images/icon-frends.png"/> {{ userTeamRank.team.memberCount }}</b></span> 
                                <span v-if="currentTab == 'gameweek'" class="gameweek"><img src="/images/icon-trophy.png"/> <b>{{ userTeamRank.points.abbr() }}</b></span>
                                <span v-else class="season"><img src="/images/icon-season-points.png"/> <b>{{ userTeamRank.points.abbr() }}</b></span>
                            </div>
                        </div>
                    </div>

                    <ul v-if="allTeamRanks.length > 0" class="team-list">
                        <li v-for="r in allTeamRanks" :key="r.id" :class="r.team != undefined && r.team.id == user.team.id ? 'my-team' : ''">
                            <div :class="'team-list__order'+(r.rank <= 3 ? ' team-list__order--rank-'+r.rank : '')">{{ r.rank }}</div>
                            <h5 class="mb-0 ml-3">{{ r.team != undefined ? r.team.name : '-' }}</h5>
                            <div class="team-list__right ml-auto">
                                <span v-if="r.team != undefined"><b><img src="/images/icon-frends.png"/> {{ r.team.memberCount }}</b></span> 
                                <span v-if="currentTab == 'gameweek'" class="gameweek"><img src="/images/icon-trophy.png"/> <b>{{ r.points.abbr() }}</b></span>
                                <span v-else class="season"><img src="/images/icon-season-points.png"/> <b>{{ r.points.abbr() }}</b></span>
                            </div>
                        </li>
                    </ul>
                    <div v-else-if="selectedId != undefined" class="d-flex flex-fill p-3">
                        <span class="text-primary m-auto" v-html="$t('team.rank_tab_no_data')"></span>
                    </div>
                    <div v-else class="d-flex flex-fill p-3">
                        <span class="text-primary m-auto" v-html="$t('team.rank_no_data'+ (currentTab == 'season' ? '_season': ''))"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'

const RankingsPopup = Vue.component('team-rankings-popup', {
    data() {
        return {
            open: false,
            currentTab: '',
            selectedId: undefined,
            options: [],
            canLoadMore: false,
            allTeamRanks: [],
            userTeamRank: undefined,
            loading: false
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        
        show() {
            this.open = true;
            this.setTab('gameweek');
        },

        hide() {
            this.open = false;
        },

        setTab(tab){
            if(tab == this.currentTab) return;

            const $this = this;
            this.currentTab = tab;
            this.options = [];
            this.canLoadMore = false;
            this.allTeamRanks = [];
            this.userTeamRank = undefined;
            
            let req = tab == 'season' ? api.seasons(1, 12) : api.gameweeks(1, 12);
            req.then(res => {
                $this.options = res.data;
                if (res.data.length > 0)
                    $this.selectedId = $this.options[0].id;
            });
        },

        loadData(nextPage = false){
            const $this = this;
            let page = nextPage ? this.page + 1 : 1;
            let req = this.currentTab == 'season' ? api.teamSeasonRankins(this.selectedId, page, 20) : api.teamGameweekRankins(this.selectedId, page, 20);

            if (page == 1)
                this.allTeamRanks = [];
            
            if (page > 1 && !this.canLoadMore)
                return;

            if (this.loading) 
                return;
            
            this.loading = true;

            req.then(res => {
                this.page = page;

                if (res.data.allTeamRanks == undefined)
                    res.data.allTeamRanks = [];

                $this.userTeamRank = res.data.userTeamRank != undefined ? res.data.userTeamRank : undefined;
                $this.canLoadMore = res.data.allTeamRanks.length == 20;

                if(page == 1) {
                    $this.allTeamRanks = res.data.allTeamRanks;
                    setTimeout(function(){ 
                        const listElm = document.querySelector('#teamRankingsPage .team-list');
                        if(listElm != undefined){
                            listElm.addEventListener('scroll', e => {
                                if(Math.ceil(listElm.scrollTop + listElm.clientHeight + page) >= listElm.scrollHeight) {
                                    $this.loadData(true);
                                }
                            });
                        }
                    }, 200);
                }
                else
                    $this.allTeamRanks = $this.allTeamRanks.concat(res.data.allTeamRanks);
            })
            .catch(e => {
                console.error(`Error loading page ${page}`);
            })
            .then(r => {
                this.loading = false;
            })
        },

        timePeriodString(startDate, endDate){
            return moment.utc(startDate).local().format('DD.MM.YYYY HH:mm') + ' - ' + moment.utc(endDate).local().format('DD.MM.YYYY HH:mm');
        }
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },

        config(){
            return this.$store.state.config.data;
        },
    },

    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        },

        selectedId(){
            this.loadData();
        }
    }
})

export default RankingsPopup
</script>